import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.008 7.5v6.875c0 .92-.746 1.667-1.666 1.667H7.258c-.92 0-1.667-.747-1.667-1.667v-8.75c0-.92.747-1.667 1.667-1.667h5.208M8.925 12.6h3.75m-3.75-2.3h3.75M8.925 8h3.75M16 2.4v3.2m1.6-1.65h-3.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);